import * as React from "react";
import type { SVGProps } from "react";
const Hotel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4274_12729)">
      <path
        fill="currentColor"
        d="M0 1.5C0 .6703.6703 0 1.5 0h21c.8297 0 1.5.6703 1.5 1.5S23.3297 3 22.5 3v18c.8297 0 1.5.6703 1.5 1.5s-.6703 1.5-1.5 1.5h-8.25v-2.25c0-1.2422-1.0078-2.25-2.25-2.25s-2.25 1.0078-2.25 2.25V24H1.5C.6703 24 0 23.3297 0 22.5S.6703 21 1.5 21V3C.6703 3 0 2.3297 0 1.5m4.5 3.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75h-1.5c-.4125 0-.75.3375-.75.75m6.75-.75c-.4125 0-.75.3375-.75.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75zm5.25.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75h-1.5c-.4125 0-.75.3375-.75.75M5.25 9c-.4125 0-.75.3375-.75.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75zm5.25.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75h-1.5c-.4125 0-.75.3375-.75.75M17.25 9c-.4125 0-.75.3375-.75.75v1.5c0 .4125.3375.75.75.75h1.5c.4125 0 .75-.3375.75-.75v-1.5c0-.4125-.3375-.75-.75-.75zm-1.875 9c.6234 0 1.1391-.5109.9844-1.1156C15.8625 14.9391 14.1 13.5 12 13.5s-3.8672 1.4391-4.3594 3.3844c-.1547.6.3656 1.1156.9844 1.1156z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4274_12729">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Hotel;
